var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconfilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  d: "M10 1.428c-1.431 0-8.571.12-8.571 2.5v2.37c0 .638.281 1.238.771 1.646l5.657 4.712v5.2A.715.715 0 0 0 9 18.428l2.57-1.928c.359-.269.573-.696.573-1.144v-2.7L17.8 7.944c.49-.408.772-1.008.772-1.646v-2.37c0-2.38-7.14-2.5-8.572-2.5m0 1.428c3.992 0 6.394.648 7.03 1.072-.636.423-3.038 1.071-7.03 1.071s-6.394-.648-7.03-1.071c.636-.424 3.038-1.072 7.03-1.072"
})));
export { SvgIconfilter as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.filter.a68ae66d.svg";